import { PureComponent } from 'react'
import * as cn from 'classnames'
import * as debounce from 'lodash/debounce'
import SvgIcon from 'components/atoms/SvgIcon'
import * as styles from 'components/features/pfm/SidebarBackButton/SidebarBackButton.css'
import ChevronSvg from 'icons/chevron.svg'

class SidebarBackButton extends PureComponent {
  private rootNode: HTMLDivElement | null = null

  render () {
    const { children } = this.props
    const className = cn(styles.sidebarBackButton)

    return (
      <div
        className={ className }
        ref={ (node) => (this.rootNode = node) }
      >
        <div className={ styles.iconWrapper }>
          <SvgIcon src={ ChevronSvg } />
        </div>
        <span className={ styles.backText }>
          Back
        </span>
        { children }
      </div>
    )
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScrollDebounced)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScrollDebounced)
  }

  private handleScroll = () => {
    const { rootNode } = this
    if (!rootNode) {
      return
    }

    rootNode.style.transform = `translateY(${ window.scrollY }px)`
  }

  private handleScrollDebounced = debounce(this.handleScroll, 200)
}

export default SidebarBackButton
